import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { CommonDataShareService } from "src/app/core/services/common-data-share-service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { SuccessDialogComponent } from "src/app/shared/components/dialog-box";
import { language } from "src/app/shared/json-asset/oneSignalSupportedLanguageList";
import {
  PushNotificationApiResponse,
  PushNotificationCreationRequest,
} from "src/app/shared/models/model";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { MilestoneCommonCheckBoxComponent } from "../../../challenges/components";

interface ExtractedData {
  id: string;
  name: string;
}

@Component({
  selector: "app-push-notification-creation",
  templateUrl: "./push-notification-creation.component.html",
  styleUrls: ["./push-notification-creation.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PushNotificationCreationComponent implements OnInit {
  constructor(
    private _ApiCallService: ApiCallService,
    private _snackBar: SnackbarCollection,
    private _ActivatedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private dataShare: CommonDataShareService,
    private _Router: Router,
    private _MatDialog: MatDialog,
    private _i18nDynamicTranslate: TranslateDynamicText
  ) {}

  @ViewChild("fileDropRef", { static: false }) fileDropRef: ElementRef;
  @ViewChild("templateType")
  templateType: MilestoneCommonCheckBoxComponent;
  @ViewChild("languageSelection")
  languageSelection: MilestoneCommonCheckBoxComponent;

  templateName = "";
  namePatterm = "^[A-Za-z0-9_ ]+$";
  nameError = false;
  nameErrorText = "";
  urlPattern = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";
  submit = false;
  uploadedImg = "";
  header = "";
  body = "";
  launchUrl = "";
  aliasCountryCode = "";
  aliasHeader = "";
  aliasBody = "";
  textSelection;
  fileToUpload: File = null;
  fileuploading = false;
  message;
  imagePath;
  files: any[] = [];
  url;
  isClone = false;
  id = null;
  layoutType = "";
  mergeTags = [];
  storeCountryCode = localStorage.getItem("serviceCountry");
  selectedLanguageType = "ALIAS";
  languageList = [];
  dropDownStatus = false;
  languageTypeList = [
    {
      displayName: "Default",
      value: "DEFAULT",
    },
    {
      displayName: "Alias",
      value: "ALIAS",
    },
  ];
  selectedMeregeTagType = "generic";
  typeOfMergeTags: ExtractedData[] = [
    {
      name: "Generic",
      id: "generic",
    },
    {
      name: "Buy X Get Y",
      id: "BUY_X_GET_Y",
    },
    {
      name: "Fixed Reward Coins Gain",
      id: "FIXED_REWARD_COINS_GAIN",
    },
    {
      name: "Fixed Amount Off",
      id: "FIXED_AMOUNT_OFF",
    },
    {
      name: "Percentage Off",
      id: "PERCENTAGE_OFF",
    },
    {
      name: "Percentage Reward Coins Gain",
      id: "PERCENTAGE_REWARD_COINS_GAIN",
    },
  ];

  async ngOnInit(): Promise<void> {
    this.getMergeTags();
    this._ActivatedRoute.params.subscribe(async (params) => {
      if (params.clone) {
        this.isClone = params.clone === "true";
      } else {
        this.isClone = false;
      }

      if (params.id && params.id !== "null") {
        this.id = params.id;

        let data: PushNotificationApiResponse | null =
          this.dataShare.getPushNotificationTemplateData() ||
          (await this.getSelectedTemplateData()); // Await inside async function

        this.prefillData(data);
      }
      this.layoutType = params.type ? params.type : "CUSTOM";
    });

    this.languageList = this.extractNameAndId(language, "displayName");
  }

  prefillData(data: PushNotificationApiResponse) {
    this.aliasCountryCode = data.layoutData.aliasCountryCode;
    this.selectedLanguageType = "DEFAULT";
    this.aliasBody = data.layoutData.aliasBody;
    this.aliasHeader = data.layoutData.aliasHeader;
    this.header = data.layoutData.header;
    this.body = data.layoutData.body;
    this.uploadedImg = data.imageUrl;
    if (!this.isClone) {
      this.templateName = data.templateName;
    } else {
      this.templateName = data.templateName + "_clone";
    }
  }

  templateNameKeyPress(event) {
    this.nameError = false;
    this.nameErrorText = "";
    if (50 - this.templateName.length === 0) {
      return false;
    }
  }

  templateNamePaste(event) {
    if (
      50 - this.templateName.length <
      event.clipboardData.getData("text").length
    ) {
      return false;
    }
  }

  updateMeasurementPointCommentHeader(evet) {
    var txtarea = document.getElementById("header") as HTMLInputElement;
    this.textSelection = txtarea.selectionStart;
  }

  updateMeasurementPointCommentBody(evet) {
    var txtarea = document.getElementById("body") as HTMLInputElement;
    this.textSelection = txtarea.selectionStart;
  }

  updateMeasurementPointCommentAliasHeader(evet) {
    var txtarea = document.getElementById("aliasHeader") as HTMLInputElement;
    this.textSelection = txtarea.selectionStart;
  }

  updateMeasurementPointCommentAliasBody(evet) {
    var txtarea = document.getElementById("aliasBody") as HTMLInputElement;
    this.textSelection = txtarea.selectionStart;
  }

  async fileBrowseHandler(event, file, type) {
    let maxSize = 1 * 1024 * 1024;
    const selectedFile = event.target.files[0];

    if (selectedFile.size > maxSize) {
      this._snackBar.openSnackBar(
        `File size should be less than ${maxSize / (1024 * 1024)} MB`,
        2000
      );
      return;
    }

    this.fileuploading = true;
    this.fileToUpload = selectedFile;
    const fd = new FormData();
    fd.append("files", this.fileToUpload, this.fileToUpload.name);
    event.target.title = selectedFile.name;

    switch (type) {
      case "image":
        this._ApiCallService.uploadImageWhatsApp(fd).subscribe(
          (response) => {
            this.uploadedImg = response["body"][0];
            this.fileuploading = false;
          },
          (err) => {
            this._snackBar.openSnackBar(err["error"]["body"], 2000);
            this.fileuploading = false;
          }
        );
        break;
    }
  }
  onFileDropped($event, type) {
    this.prepareFilesList($event);
    this.setFiles2($event);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
  }

  setFiles2(event) {
    // this.image = true;
    const files = event.target.files;
    if (files.length === 0) return;

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    };
  }

  removeUrl(type) {
    this.uploadedImg = "";
    this.resetFileInput(this.fileDropRef);
  }

  resetFileInput(fileInput: ElementRef) {
    fileInput.nativeElement.value = "";
    fileInput.nativeElement.title = "";
  }

  saveTemplate() {
    this.submit = true;

    if (this.templateName.length < 3 || this.body.length === 0) {
      return;
    }

    let data: PushNotificationCreationRequest = {
      id: this.id ? (!this.isClone ? this.id : null) : null,
      templateName: this.templateName,
      header: this.header,
      body: this.body,
      imageUrl: this.uploadedImg,
      type: this.id == null ? "create" : "update",
      layoutType: this.layoutType,
      aliasBody: this.aliasBody,
      aliasCountryCode: this.aliasCountryCode,
      aliasHeader: this.aliasHeader,
    };
    this.saveTemplateApi(data).then(
      (result) => {
        if (result["body"]) {
          this.id = result["body"];
          this.openSuccessDialog(
            this._i18nDynamicTranslate.transform(
              this.id
                ? "Your push notification template has been updated successfully."
                : "Your push notification template has been created successfully.",
              ["POS_PAGE"]
            ),
            this._i18nDynamicTranslate.transform("OK", ["POS_PAGE"])
          );
        }
      },
      (error) => {
        this.nameError = true;
        this.nameErrorText = error.body;
      }
    );
  }

  addMergeTag(
    value,
    elementId,
    segmentSelectId,
    segmentSelectPanelId,
    keyboardDownIconElementId,
    type
  ) {
    const txtarea = document.getElementById(type);
    const element = document.getElementById(elementId);
    const segmentSelect = document.getElementById(segmentSelectId);
    const segmentSelectPanel = document.getElementById(segmentSelectPanelId);
    const keyboardDownIconElement = document.getElementById(
      keyboardDownIconElementId
    );

    // Close dropdown
    this.dropDownStatus = false;
    Object.assign(element.style, { height: "0px" });
    Object.assign(segmentSelect.style, { overflow: "hidden" });
    Object.assign(segmentSelectPanel.style, {
      boxShadow: "unset",
      border: "1px solid #919191",
    });
    Object.assign(keyboardDownIconElement.style, { transform: "rotate(0deg)" });

    // Handle text insertion based on type
    const textFields = {
      aliasHeader: "aliasHeader",
      aliasBody: "aliasBody",
      header: "header",
      body: "body",
    };

    if (textFields[type] && txtarea) {
      this[textFields[type]] =
        this[textFields[type]].slice(0, this.textSelection) +
        value +
        this[textFields[type]].slice(this.textSelection);

      txtarea.focus();
    }
  }

  toggleSelect(
    event,
    elementId,
    segmentSelectId,
    segmentSelectPanelId,
    keyboardDownIconElementId,
    type
  ) {
    event.stopPropagation();

    const txtarea = document.getElementById(type);
    let element = document.getElementById(elementId);
    let segmentSelect = document.getElementById(segmentSelectId);
    let segmentSelectPanel = document.getElementById(segmentSelectPanelId);
    let keyboardDownIconElement = document.getElementById(
      keyboardDownIconElementId
    );
    txtarea.focus();
    if (this.dropDownStatus) {
      this.dropDownStatus = false;
      element.style.height = "0px";
      segmentSelect.style.overflow = "hidden";
      segmentSelectPanel.style.boxShadow = "unset";
      segmentSelectPanel.style.boxShadow = "0 0 10px 0 #c6ced685";
      keyboardDownIconElement.style.transform = "rotate(0deg)";
      //this.getSegmentCount();
      //element.style.display = 'none';
    } else {
      this.dropDownStatus = true;
      element.style.height = "140px";
      segmentSelect.style.overflow = "auto";
      segmentSelectPanel.style.boxShadow = "0px 1px 6px 0px #25a7f9";
      keyboardDownIconElement.style.transform = "rotate(180deg)";
      //element.style.display = 'block';
    }
  }

  openSuccessDialog(message, buttonText) {
    const dialogRef = this._MatDialog.open(SuccessDialogComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "20%",
      disableClose: true,
      data: {
        message: message,
        buttonText: buttonText,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this._Router.navigate([
        "app/push-notification/choose-layout",
        { id: this.id },
      ]);
    });
  }

  setLanguageType(type) {
    this.selectedLanguageType = type.value;
  }

  addAliasLanguage() {
    this.aliasCountryCode = this.getValueByAlpha2Code(
      this.storeCountryCode,
      language
    );
    console.log(this.aliasCountryCode, this.storeCountryCode);
  }

  getValueByAlpha2Code(alpha2Code: string, languages: any[]): string | null {
    const language = languages.find((lang) =>
      lang.alpha2Code.includes(alpha2Code)
    );
    return language ? language.value : null;
  }

  extractNameAndId(data, keyName): ExtractedData[] {
    if (data) {
      return data.map((item) => ({
        id: item.value,
        name: item[keyName],
      }));
    }
  }

  checkWhetherAlias() {
    return (
      this.aliasCountryCode &&
      this.aliasCountryCode?.length > 0 &&
      this.selectedLanguageType === "ALIAS"
    );
  }

  async getSelectedTemplateData(): Promise<PushNotificationApiResponse | null> {
    try {
      const result = await this.getTemplatesApi(); // Await the API call
      console.log(result);

      if (result) {
        let finalTemplates = result["body"];
        return this.getSelectedTemplate(finalTemplates);
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
      return null;
    }
  }

  getSelectedTemplate(data) {
    return data.find((x) => x.id == this.id);
  }

  getMergeTags() {
    this.getMergeTagsApi().then(
      (response) => {
        if (response) {
          console.log("MERGETAGS", response);
          let data: any = [];
          for (let k in response["body"]) {
            let n: any = {};
            n.name = k;
            n.value = response["body"][k];
            data.push(n);
          }
          this.mergeTags = data;
          console.log("TAGS", this.mergeTags);
        }
      },
      (error) => {}
    );
  }

  getMergeTagsApi() {
    return new Promise((resolve, reject) => {
      this._ApiCallService
        .getMergeTagsPushNotification(this.selectedMeregeTagType)
        .subscribe(
          (res) => {
            console.log(res);
            resolve(res);
          },
          (err) => {
            console.log(err.error);

            reject(err.error);
          }
        );
    });
  }

  tagTypeSelected(value) {
    this.selectedMeregeTagType = value;
    this.getMergeTags();
  }

  languageSelected(value) {
    this.aliasCountryCode = value;
  }

  saveTemplateApi(data) {
    return new Promise((resolve, reject) => {
      this._ApiCallService.savePushNitificationTemplate(data).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);

          reject(err.error);
        }
      );
    });
  }

  getTemplatesApi() {
    return new Promise((resolve, reject) => {
      this._ApiCallService.getPushNotificationTemplates("ALL").subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);

          reject(err);
        }
      );
    });
  }
}
